<form [formGroup]="notificationCreationForm" (ngSubmit)="onSubmit($event)">
    <div class="modal-body">
        <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>

        <div class="mvd_alert--container open"
             ng-reflect-klass="mvd_alert--container"
             ng-reflect-ng-class="[object Object]"
             *ngIf="readyToDisplayValidationMessages == true">
            <div class="mvd_alert--results">
                <h2 class="mvd_alert--header">Alerts <button class="close" type="button">×</button></h2>
                <ul class="mvd_alert__group">
                    <li class="mvd_alert--error"
                        *ngIf="notificationCreationForm.controls.messageText.hasError('required')"><strong>Error -</strong>A Notification Message is required.</li>
                    <li class="mvd_alert--error"
                        *ngIf="notificationCreationForm.controls.messageText.hasError('messageTooLong')"><strong>Error -</strong>The Notification Message is too long for the selected Delivery Channel(s).</li>
                    <li class="mvd_alert--error"
                        *ngIf="notificationCreationForm.controls.customerNumberId.hasError('required')"><strong>Error -</strong>At least one recipient is required.</li>
                    <li class="mvd_alert--error"
                        *ngIf="notificationCreationForm.controls.expirationDate.hasError('required')"><strong>Error -</strong>An Expiration Date is required for the selected Delivery Channel(s).</li>
                    <li class="mvd_alert--error"
                        *ngIf="notificationCreationForm.controls.channel.hasError('required')"><strong>Error -</strong>At least one Delivery Channel is required.</li>
                </ul>
            </div>
        </div>
        <fieldset>
            <div class="row">
                <div class="col-sm-12 mvd_form-group">
                    <label>Send Notification to</label>
                    <div class="switch--notification">
                        <toggle-switch [option1]="'Users'" [option2]="'Customers'" (selectedOption)="setReceipientType($event)">
                            <span option1>Users</span>
                            <span option2>Customers</span>
                        </toggle-switch>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="mvd_form-group col-md-6">
                    <label class="required" title="* Required">Notification Message</label>
                    <textarea rows="6" formControlName="messageText"></textarea>
                </div>
                <div class="mvd_form-group col-sm-6 col-md-3">
                    <label class="required" title="* Required" *ngIf="notificationChannels.length > 0">Delivery Channel</label>
                    <ul class="list--bulletless--content">
                        <li *ngFor="let channel of notificationChannels">
                            <label class="mvd_label--inline" [ngClass]="{'hidden': !canDisplay(channel)}">
                                <input type="checkbox" value="{{channel.notificationChannelTypeValue}}" [hidden]='!canDisplay(channel)' (click)="channelSelectionMade($event)" #notificationChannelChildren />
                                {{channel.notificationChannelTypeDisplayValue}}
                            </label>
                        </li>
                    </ul>
                </div>
                <div class="mvd_form-group col-sm-3">
                    <label class="required" title="* Required">Expiration Date</label>
                    <p-calendar placeholder="mm/dd/yyyy hh:mm"
                                [showIcon]="true"
                                showTime="true"
                                hourFormat="12"
                                dateFormat="mm/dd/yy"
                                [disabled]="enableExpirationDate()"
                                formControlName="expirationDate">
                    </p-calendar>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6 mvd_form-group" [hidden]="getUserType()">
                    <customer-search-bar [label]="'Customer Search'" (onItemSelected)="customerSelected($event)" *ngIf="enableCustomerField()"></customer-search-bar>
                </div>
            </div>
            <div class="row">
                <div class="mvd_form-group col-8 col-sm-9 col-md-5" [hidden]="!getUserType()">
                    <label>Team Members</label>
                    <div class="mvd_form-control">{{selectedTeamNames}}</div>
                </div>

                <div class="mvd_form-group col-4 col-sm-3 col-md-2" [hidden]="!getUserType()">
                    <button class="icon--add btn--default" type="button" (click)="toButtonClick($event)">Member</button>
                </div>

                <div class="mvd_form-group col-sm-5" [hidden]="!getUserType()">
                    <label>Select Users</label>
                    <p-multiSelect [options]="users" formControlName="userLoginIds"></p-multiSelect>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="modal-footer">
        <div class="btn--group">
            <button class="btn--default" type="button" mat-dialog-close aria-label="Close">Close</button>
            <button class="btn--primary" type="button" (click)="onSubmit($event)">Send</button>
        </div>
    </div>
</form>